import { type ITranslation } from '@mahawi/eshop-common/dist/src/types';
import { type ILanguageState } from 'customer/react/reducers/language/types';
import { type IProductState } from 'customer/react/reducers/product/types';
import Markdown from 'markdown-to-jsx';
import React, { memo, useMemo } from 'react';
import { connect } from 'react-redux';

function Description({
  Product,
  Language,
}: {
  Product: IProductState;
  Language: ILanguageState;
}): React.JSX.Element {
  const description: ITranslation | undefined = useMemo(():
    ITranslation | undefined => {
    if (!Product.product?.descriptions) return undefined;
    return (
      Product.product.descriptions.find(
        (n: ITranslation): boolean => n.code === Language.languageType.code,
      ) ||
      Product.product.descriptions.find(
        (n: ITranslation): boolean => n.code.toLowerCase() === 'en',
      )
    );
  }, [Product.product?.descriptions, Language.languageType.code]);

  return (
    <div className="product description">
      <Markdown className="container margin--1">
        {description?.value || ''}
      </Markdown>
    </div>
  );
}

const mapStateToProps = ({ Product, Language }) => ({ Product, Language });

export default connect(mapStateToProps)(memo(Description));
